module.exports = __webpack_public_path__ + "gh.svg?2bbd0bee0c23661b5498de8918fa0a26";